// const POLYFILL_MODULE = 'core';
import './svg4everybody/async-load__svg4everybody';
import 'babel-polyfill';

window.Promise = Promise;



// WEBPACK FOOTER //
// ./project/client/src/core/polyfills/index.js